export default __webpack_public_path__ + "static/media/plusIconNew.746fa359.svg";